function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_13347",
  width: 24,
  height: 24,
  fill: "#00001f"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_69015",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_148486",
  d: "M9.2,19.657h7.134A1.493,1.493,0,0,0,18,18.1L18.48,7.2h1.047a.659.659,0,1,0,0-1.318H16.25V4.748a1.833,1.833,0,0,0-2.064-1.914H11.323A1.827,1.827,0,0,0,9.266,4.748v1.13H6A.659.659,0,1,0,6,7.2H7.059l.475,10.9A1.493,1.493,0,0,0,9.2,19.657Zm1.62-14.841a.551.551,0,0,1,.61-.565h2.659a.553.553,0,0,1,.618.565V5.878H10.818Zm-.467,12.551a.489.489,0,0,1-.52-.5L9.605,8.847a.471.471,0,0,1,.512-.5.489.489,0,0,1,.52.5l.226,8.023A.471.471,0,0,1,10.351,17.367Zm2.411,0a.491.491,0,0,1-.527-.5V8.847a.528.528,0,0,1,1.055,0V16.87A.487.487,0,0,1,12.762,17.367Zm2.411,0a.471.471,0,0,1-.512-.5l.226-8.023a.483.483,0,0,1,.52-.49.467.467,0,0,1,.512.5l-.226,8.016A.489.489,0,0,1,15.173,17.367Z",
  transform: "translate(-0.762 -0.405)"
}));

function SvgTrashBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBasket);
export default __webpack_public_path__ + "static/media/trash-basket.7f965769.svg";
export { ForwardRef as ReactComponent };